import React, { useEffect, useState } from 'react'
import YouTube from 'react-youtube';
import axios_instance from '../../API/Axios'
import './Row.css';
import movieTrailer from 'movie-trailer';

function Row({ title, fetch_Url, fetch_ImgUrl, isLargeRow}) {
    const [movies, setMovies] = useState([]);
    const [trailer_Url, setTrailer_Url] = useState("")
    // a snippet of code which run based on conditions
    useEffect(() => {
        // [] run once, row loads and don't run again! (only on Page Load)
        async function fetchData() {
            const req = await axios_instance.get(fetch_Url)
            // console.log(req.data.results);
            setMovies(req.data.results)
            return req;
        }
        fetchData();
    }, [fetch_Url])

  const opts = {
    height: "390",
    width: "100%",
    playerVars: {
        autoplay: 1
    }
}

const handleClick = (movie) => {
    if (trailer_Url) {
        setTrailer_Url('')
    } else {
        movieTrailer(movie?.name || "").then(url => {
            const urlParams = new URLSearchParams(new URL(url).search);
            setTrailer_Url(urlParams.get('v'));
        
        }).catch(error => console.log(error))
    }
}

    return (
        <div className="row">
            {/* Movie Catagory */}
            <h2>{title}</h2>
            <div className="row_posters">
                {/* Several row posters */}
                {movies.map(movie => (
                    <img 
                    key={movie.id} 
                    onClick={ () => handleClick(movie)}
                    className={`row_poster ${isLargeRow && "row_poster_Large"}`} 
                    src={`${fetch_ImgUrl}${isLargeRow? movie.poster_path: movie.backdrop_path}`} 
                    alt={movie.name} 
                    />
                ))}

            </div>
       {trailer_Url && <YouTube videoId={trailer_Url} opts={opts}/> }
        </div>
    )
}

export default Row
